export enum ModelType {
    Sourced = 'sourced',
    Last = 'last',
    Even = 'even',
    Custom = 'custom',
}
